"use client"

import type { SearchProductHit } from "../types"
import Link from "next/link"
import Image from "@modules/common/components/cdn-image"

const ProductImage = ({ product }: { product: SearchProductHit }) => {
  if (!product.thumbnail) {
    return (
      <div className="flex aspect-[3/4] w-14 items-center justify-center bg-[#f0ece4] text-[10px] uppercase tracking-[0.18em] text-[#8a7f72] md:w-16">
        {process.env.NEXT_PUBLIC_BRAND_SHORT_NAME || "Store"}
      </div>
    )
  }

  return (
    <Image
      src={product.thumbnail}
      alt={product.title}
      width={64}
      height={85}
      className="aspect-[3/4] w-14 bg-[#f0ece4] object-cover md:w-16"
    />
  )
}

export default function SearchProductList({
  products,
  onSelect,
}: {
  products: SearchProductHit[]
  onSelect?: () => void
}) {
  return (
    <div className="divide-y divide-[#E5E5E5]">
      {products.map((product) => (
        <Link
          key={product.id}
          href={product.url}
          onClick={onSelect}
          className="grid grid-cols-[56px_minmax(0,1fr)] gap-3 py-3 transition-colors hover:text-[#3D5240] md:grid-cols-[64px_minmax(0,1fr)] md:gap-4"
        >
          <ProductImage product={product} />
          <span className="flex min-w-0 flex-col justify-center">
            <span className="line-clamp-2 text-sm font-medium leading-5 text-[#181512]">
              {product.title}
            </span>
            {product.style && (
              <span className="mt-0.5 text-[11px] uppercase tracking-[0.12em] text-[#8a7f72]">
                Style № {product.style}
              </span>
            )}
            <span className="mt-1 flex flex-wrap items-center gap-2 text-xs text-[#8a7f72]">
              {product.price && (
                <span
                  className={
                    product.priceType === "sale"
                      ? "font-medium text-[#b85c00]"
                      : "font-medium text-[#181512]"
                  }
                >
                  {product.price}
                </span>
              )}
              {product.originalPrice && product.priceType === "sale" && (
                <span className="line-through">{product.originalPrice}</span>
              )}
              {!product.inStock && <span>Out of stock</span>}
            </span>
          </span>
        </Link>
      ))}
    </div>
  )
}
